var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNamada(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 211 211",
    fill: "#FFFF00",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M146.418 105.509h-39.451v39.451h39.451zm-78.92-39.472c21.773 0 39.45 17.677 39.45 39.45h-39.45zm0 39.472L44.72 144.96h45.553zm79.066-.034c10.887 0 19.712-8.826 19.712-19.713s-8.825-19.713-19.712-19.713-19.713 8.826-19.713 19.713 8.826 19.713 19.713 19.713"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M105.5 210.997c-28.18 0-54.674-10.972-74.6-30.901C10.973 160.171 0 133.677 0 105.497s10.972-54.671 30.9-74.596C50.827 10.972 77.32 0 105.5 0s54.674 10.972 74.599 30.9C200.025 50.827 211 77.32 211 105.5s-10.972 54.674-30.901 74.599C160.174 200.025 133.68 211 105.5 211zm0-197.926c-24.688 0-47.899 9.613-65.354 27.072s-27.072 40.666-27.072 65.354c0 24.687 9.613 47.899 27.072 65.354 17.458 17.458 40.666 27.072 65.354 27.072s47.899-9.614 65.354-27.072 27.072-40.667 27.072-65.354c0-24.688-9.613-47.899-27.072-65.354C153.396 22.687 130.188 13.07 105.5 13.07"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNamada);
export default __webpack_public_path__ + "static/media/namada.09e88bbde562b5836eab19f39ebe6ef5.svg";
export { ForwardRef as ReactComponent };